<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thông tin thể loại bài viết</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col>
                                <b-form-group label="Thể loại bài viết:"
                                              label-for="blogCategoryIds"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right">
                                    <select2 class="no-padding col-10" v-model="blog.blogCategoryIds"
                                             v-if="blogCategories.length > 0 && editing"
                                             :options="blogCategories"
                                             allowClear="true"
                                             multiple="true"
                                             placeholder="--- Chọn ---"></select2>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.blogCategoryName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Thẻ bài viết:"
                                              label-for="tagIds"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right">
                                    <!--<b-form-input type="text" id="blogCategoryIds"
                                                  class="col-10"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.blog.title.$model"
                                                  :state="$v.blog.title.$dirty? !$v.blog.title.$error : null">
                                    </b-form-input>-->
                                    <select2 class="no-padding col-10" 
                                             v-model="blog.tagIds"
                                             v-if="editing && tags.length > 0"
                                             :options="tags"
                                             allowClear="true"
                                             multiple="true"
                                             placeholder="--- Chọn ---"></select2>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.tagName }}</label>

                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tiêu đề bài viết:"
                                              label-for="name"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right"
                                              :label-class="editing ? 'required' : ''">
                                    <b-form-input type="text" id="title"
                                                  v-if="editing"
                                                  class="col-10"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.blog.title.$model"
                                                  :state="$v.blog.title.$dirty? !$v.blog.title.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tiêu đề bài viết
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.title }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tiêu đề không dấu:"
                                              title="Phục vụ đường link"
                                              label-for="name"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" id="slug"
                                                  v-if="editing"
                                                  class="col-10"
                                                  aria-describedby="codeFeedback"
                                                  v-model="blog.slug">
                                    </b-form-input>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.slug }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Mô tả:"
                                              label-for="name"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-if="editing" v-model="$v.blog.description.$model"
                                                     :state=" $v.blog.description.$model && $v.blog.description.$dirty ? !$v.blog.description.$error : null"
                                                     class="col-10" id="description" rows="5"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.description.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.description }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Chi tiết:"
                                              label-for="name"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true"
                                              id="editor-css">
                                    <b-col md="10" v-if="editing" class="no-padding">
                                        <b-form-input type="text"
                                                      style="display:none;"
                                                      aria-describedby="codeFeedback"
                                                      v-model="$v.blog.detail.$model"
                                                      :state="$v.blog.detail.$dirty? !$v.blog.detail.$error : null">
                                        </b-form-input>
                                        <DocumentEditor ref="doc" v-model="blog.detail"></DocumentEditor>
                                        <b-form-invalid-feedback v-if="!$v.blog.detail.required">
                                            Vui lòng nhập chi tiết !
                                        </b-form-invalid-feedback>
                                    </b-col>
                                    <label class="col-form-label col-10" v-if="!editing" v-html="blog.detail"></label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tệp đính kèm:"
                                              label-for="file"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-file v-if="editing" v-model="blog.file"
                                                 class="col-10 no-padding"
                                                 accept="image/*"
                                                 browse-text="Chọn"
                                                 placeholder="Chọn tệp tải lên..."></b-form-file>
                                    <label class="col-form-label col-10" v-if="blog.file == null || blog.file.length == 0">{{ blog.urlImage }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaTitle:"
                                              label-for="name"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-if="editing" v-model="$v.blog.metaTitle.$model"
                                                     :state=" $v.blog.metaTitle.$model && $v.blog.metaTitle.$dirty ? !$v.blog.metaTitle.$error : null"
                                                     class="col-10" id="MetaTitle" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.metaTitle.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.metaTitle }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaKeywords:"
                                              label-for="MetaKeywords"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-if="editing" v-model="$v.blog.metaKeywords.$model"
                                                     :state="$v.blog.metaKeywords.$model && $v.blog.metaKeywords.$dirty ? !$v.blog.metaKeywords.$error : null"
                                                     class="col-10" id="MetaKeywords" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.metaKeywords.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.metaKeywords }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaDescriptions:"
                                              label-for="MetaDescriptions"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-if="editing" v-model="$v.blog.metaDescriptions.$model"
                                                     :state=" $v.blog.metaDescriptions.$model && $v.blog.metaDescriptions.$dirty ? !$v.blog.metaDescriptions.$error : null"
                                                     class="col-10" id="MetaDescriptions" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.metaDescriptions.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-10" v-if="!editing">{{ blog.metaDescriptions }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Trạng thái:"
                                              label-align="right"
                                              label-for="status"
                                              :label-cols="2"
                                              :horizontal="true">
                                    <b-form-checkbox id="status" v-if="editing" v-model="blog.status" class="col-10 col-form-label"></b-form-checkbox>
                                    <label class="col-form-label col-10 " v-if="!editing">{{ $store.getters.getStatusName(blog.status ? 1 : 0) }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="2">
                                    <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                                    <b-button type="button" variant="secondary" @click="back" v-if="!editing">Quay lại</b-button>
                                    <b-button type="submit" variant="primary" v-if="editing && authorize(['ManageBlog'])">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel" v-if="editing">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required, minLength, maxLength, } from 'vuelidate/lib/validators'
    import { authorizationMixin } from '@/shared/mixins'
    import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

    export default {
        name: 'BlogDetail',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                blog: {
                    file: null
                },
                editing: this.$route.meta.editing,
            }
        },
        computed: {
            blogId() {
                return this.$route.params.blogId;
            },
            ...mapState({
                blogCategories: (state, getters) => state.common.blogCategories,
                tags: (state, getters) => state.common.tags,
            })
        },
        validations: {
            blog: {
                title: {
                    required,
                    maxLength: maxLength(128)
                },
                description: {
                    required
                },
                detail: {
                    required
                },
                metaTitle: {
                    maxLength: maxLength(256)
                },
                metaKeywords: {
                    maxLength: maxLength(256)
                },
                metaDescriptions: {
                    maxLength: maxLength(256)
                },
            },
        },
        watch: {
            'blog.title'(value) {
                this.blog.slug = value.convertslug();
            }
        },
        created() {
            this.loadBlogDetail();
        },
        mounted(){
            const element = document.getElementById("editor-css");
            element.querySelector(".bv-no-focus-ring").classList.add("col-md-10");
        },
        methods: {
            loadBlogDetail() {
                var vm = this;
                return this.$services.get(`master-data/blogs/${this.blogId}`).done(blog => {
                    vm.blog = blog;
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '/master-data/blogs' });
            },
            cancel() {
                var vm = this;
                this.loadBlogDetail().done(() => vm.editing = false);
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.upload(`master-data/blogs`, this.blog).done(() => {
                        vm.$toastr.s('Cập nhật bài viết thành công');
                        vm.cancel();
                    });
                }
            },
        }
    }
</script>
<style>
    .ck-editor .ck-editor__main .ck-content {
        min-height: 200px;
    }

    .ck-editor__editable_inline {
        min-height: 200px;
    }
    .bv-no-focus-ring .col{

    }
</style>